import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-building-item',
  templateUrl: './building-item.component.html',
  styleUrls: ['./building-item.component.scss'],
})
export class BuildingItemComponent implements OnInit, OnDestroy {
  @Input() name: string | undefined;
  @Input() id: string | undefined;
  subscription: Subscription | undefined;
  sharedData: any;
  firstCallDone: boolean;

  constructor(
    private sharedDataService: SharedDataService,
    private commonService: CommonService,
  ) {
    this.firstCallDone = false;
  }

  /**
   * @description: runs on when component is initialized. This method subscribes loginservice.
   *
   * @input {none}
   * @output {void}
   */

  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   * @description: buildingClickHandler method perform selection of buiding from buildinglist
   *               and set the selectedUnit and respective floor in the shared-data-service.
   * @input { none }
   * @output { String }
   */

  buildingClickHandler(id: string | undefined, name: string | undefined) {

    // Check if it's the first time the function is being called
    if (this.sharedData.selectedBuilding.buildingId === id && !this.firstCallDone) {
      // First time: Don't return, let it fetch the values
      this.firstCallDone = true
      // this.firstCallDone = true;
    } else if (this.sharedData.selectedBuilding.buildingId === id) {
      // If the buildingId is the same again (subsequent call), return to prevent any changes
      return;
    }
    this.sharedDataService.setSelectedBuilding({
      buildingId: id,
      buildingName: name,
    });
    this.sharedDataService.setSelectedUnit({
      unitName: null,
      unitId: null,
    });
    this.sharedDataService.setSelectedFloor({
      floorId: null,
      floorName: null,
    });

    this.commonService.setLoadingUnitAndAccessPoint(false); // reset unit / access point state change while building change
    this.commonService.setLoadingBuilding(true); //  show loader when building is change
    this.firstCallDone = true
  }

  /**
   * @description: runs just before component unmount. Unsubscribes the login service
   * @input {none}
   * @output {void}
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
